module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1511-5a90034c5d821b9502817f38b5fe8816.png";